module.exports = __webpack_public_path__ + "0241dbb5a93c8694d21fb9980af17d8c.mdl";